import { render, staticRenderFns } from "./ExtratoValeDialog.vue?vue&type=template&id=0fa5e4e6&"
import script from "./ExtratoValeDialog.vue?vue&type=script&lang=js&"
export * from "./ExtratoValeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports